<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'nowak-crm'
}
</script>

<style>
  /* CSS */
</style>



// WEBPACK FOOTER //
// src/App.vue